import React from "react"
import * as layouts from "layouts"
import * as typography from "typography"
import * as selector from "brands/selector"
import { Link } from "react-router-dom"
import * as brands from "brands"
import * as routing from "./routing"

export function MetricsContainer(props: React.PropsWithChildren<selector.props>): JSX.Element {
	const { urlgen, children } = props
	return (
		<layouts.backgrounds.Grey className="brandguard-metrics" flex="0 1 100%">
			<layouts.containers.flex justifyContent="center" flex="1" data-testid="metrics-container">
				<layouts.containers.flex p="50px" pt="25px" flexDirection="column" width="100%" overflowY="hidden">
					<layouts.containers.flex flexDirection="row" width="100%" textAlign="left" boxShadow="none" mb="20px">
						<layouts.containers.flex flex="2">
							<typography.h3 color={layouts.theme.colors.grey.medium}>Metrics</typography.h3>
						</layouts.containers.flex>
						<layouts.containers.flex flex="2" justifyContent="end" height="48px">
							<selector.BrandSelector width="30%" urlgen={urlgen} />
						</layouts.containers.flex>
					</layouts.containers.flex>
					{children}
				</layouts.containers.flex>
			</layouts.containers.flex>
		</layouts.backgrounds.Grey>
	)
}

interface tabDef {
	label: string
	urlgen: (bid: string) => string
}

const tabs: tabDef[] = [
	{ label: "Approvals", urlgen: routing.metrics_approvals },
	{ label: "Training", urlgen: routing.metrics_training },
	{ label: "Asset Types", urlgen: routing.metrics_asset_types },
	{ label: "Score Failures", urlgen: routing.metrics_score_failures },
	{ label: "Model Accuracy", urlgen: routing.metrics_model_accuracy },
	{ label: "Feedback Trends", urlgen: routing.metrics_feedback_trends },
]

function MetricsTabNav(props: { active: string }): JSX.Element {
	const brand = brands.caching.useCached()
	return (
		<layouts.containers.flex flexDirection="row" width="100%" textAlign="left" boxShadow="none" mb="10px">
			<layouts.containers.flex flexDirection="row" flex="1" borderBottom={layouts.theme.borders.grey.dark50alphamedium}>
				{tabs.map((tab, idx) => {
					const isActive = tab.label === props.active
					const separator = idx < tabs.length - 1 && (
						<layouts.containers.flex mx="20px" my="4px" borderRight={layouts.theme.borders.grey.dark50alphamedium} />
					)

					if (isActive) {
						return (
							<React.Fragment key={tab.label}>
								<layouts.containers.flex
									p="5px"
									flexDirection="row"
									borderBottom={`2px solid ${layouts.theme.colors.blue.blue}`}
								>
									<layouts.containers.flex fontSize="14px" fontWeight="700" color={layouts.theme.colors.grey.dark50}>
										{tab.label}
									</layouts.containers.flex>
								</layouts.containers.flex>
								{separator}
							</React.Fragment>
						)
					}

					return (
						<React.Fragment key={tab.label}>
							<Link to={tab.urlgen(brand.id)} style={{ textDecoration: "none" }}>
								<layouts.containers.flex p="5px" flexDirection="row">
									<layouts.containers.span opacity="0.5" color={layouts.theme.colors.grey.dark50} fontSize="14px">
										{tab.label}
									</layouts.containers.span>
								</layouts.containers.flex>
							</Link>
							{separator}
						</React.Fragment>
					)
				})}
			</layouts.containers.flex>
		</layouts.containers.flex>
	)
}

export function MetricsApprovalsActiveLink(): JSX.Element {
	return <MetricsTabNav active="Approvals" />
}

export function MetricsTrainingActiveLink(): JSX.Element {
	return <MetricsTabNav active="Training" />
}

export function MetricsAssetTypesActiveLink(): JSX.Element {
	return <MetricsTabNav active="Asset Types" />
}

export function MetricsScoreFailuresActiveLink(): JSX.Element {
	return <MetricsTabNav active="Score Failures" />
}

export function MetricsModelAccuracyActiveLink(): JSX.Element {
	return <MetricsTabNav active="Model Accuracy" />
}

export function MetricsFeedbackTrendsActiveLink(): JSX.Element {
	return <MetricsTabNav active="Feedback Trends" />
}
